import { takeEvery } from 'redux-saga'

import actions from 'actions'
import { readCropperFile } from './cropper-sagas'

export function* watchCropperSelect() {
  yield* takeEvery(actions.CROPPER_SELECT, readCropperFile)
}



/** WEBPACK FOOTER **
 ** ./src/sagas/cropper/cropper-watchers.js
 **/